export default __webpack_public_path__ + "img/my-points-hero-95f745ac848b179aee090150f562da85.png";